import client from './client';

export function getMySrhtChecklist() {
  return client.get('/api/srht-checklists/me');
}

export function acknowledgeSrhtChecklistCompletion() {
  return client.post('/api/srht-checklists/me/completion-ack');
}

export function saveMySrhtChecklistItem(itemId, data) {
  return client.put(`/api/srht-checklists/me/items/${itemId}`, data);
}

export function getSrhtChecklistInstructors() {
  return client.get('/api/srht-checklists/instructors');
}

export function getSrhtChecklistAdminOpenList() {
  return client.get('/api/srht-checklists/admin/open');
}

export function getSrhtChecklistAdminDetail(checklistId) {
  return client.get(`/api/srht-checklists/admin/${checklistId}`);
}

export function finalizeSrhtChecklist(checklistId) {
  return client.post(`/api/srht-checklists/admin/${checklistId}/finalize`);
}

export function exportSrhtChecklistPdf(checklistId) {
  return client.post(`/api/srht-checklists/admin/${checklistId}/export-pdf`, {}, {
    responseType: 'blob',
  });
}
